import { useState as i, useEffect as u } from "react";
const f = (s, t) => {
  const [o, a] = i(t ? "loading" : "idle");
  return u(
    () => {
      if (!t) {
        a("idle");
        return;
      }
      let e = document.querySelector(`${s}[src="${t}"],${s}[href="${t}"]`);
      if (e) {
        const r = e.getAttribute("data-status");
        a(r);
      } else {
        e = document.createElement(s), e instanceof HTMLLinkElement ? (e.href = t, e.rel = "stylesheet", e.type = "text/css") : (e.src = t, e.async = !0), e.setAttribute("data-status", "loading"), document.body.appendChild(e);
        const r = (d) => {
          e == null || e.setAttribute("data-status", d.type === "load" ? "ready" : "error");
        };
        e.addEventListener("load", r), e.addEventListener("error", r);
      }
      const n = (r) => {
        a(r.type === "load" ? "ready" : "error");
      };
      return e.addEventListener("load", n), e.addEventListener("error", n), () => {
        e && (e.removeEventListener("load", n), e.removeEventListener("error", n));
      };
    },
    [s, t]
  ), o;
};
export {
  f as default
};
